/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import '../content-block/index';
import './content-group-simple';
import '../content-group/content-group-copy';
import '../content-group/content-group-heading';
import '../content-item/content-item';
import '../content-item/content-item-heading';
import '../content-item/content-item-copy';
import '../cta/card-cta';
import '../cta/card-cta-footer';
import '../cta/video-cta-container';
import '../image/image';
